'use es6';

import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Spider = ({
  id
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: `spider_${id}`,
    children: [/*#__PURE__*/_jsx("div", {
      className: "eye left"
    }), /*#__PURE__*/_jsx("div", {
      className: "eye right"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg left"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg left"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg left"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg left"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg right"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg right"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg right"
    }), /*#__PURE__*/_jsx("span", {
      className: "leg right"
    })]
  });
};

const isTabletOrAbove = () => {
  return window.screen.width * window.devicePixelRatio > 768;
};

export const Spiders = () => {
  const showSpider = isTabletOrAbove();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Spider, {
      id: 0
    }), showSpider && /*#__PURE__*/_jsx(Spider, {
      id: 1
    }), /*#__PURE__*/_jsx(Spider, {
      id: 2
    }), /*#__PURE__*/_jsx(Spider, {
      id: 3
    }), showSpider && /*#__PURE__*/_jsx(Spider, {
      id: 4
    }), /*#__PURE__*/_jsx(Spider, {
      id: 5
    })]
  });
};